import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import About from './components/About';
import Home from './components/Home';
import Contact from './components/Contact';
import Footer from './components/Footer';

import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import Service from './components/Service';

function App() {
  useEffect(() => {
    NotificationManager.success('Code Wise Studio', 'Welcome to', 3000);
  }, []);

  return (
    <div className="App-container">
      <BrowserRouter>
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="service" element={<Service />} />
          <Route path="contact" element={<Contact />} />
        </Routes>
        <Footer />
        {/* Include the NotificationContainer */}
        <NotificationContainer />
      </BrowserRouter>
    </div>
  );
}

export default App;
